import ContactForm from '@/components/UI/ContactForm';
import SeoHelmet from '@/components/UI/SeoHelmet';
import footerBg from '@/public/svg/obst-bg.svg';
import seoImg from "@/public/img/seo/kontakt.png";

export default function AboutUsPage() {
    return (
        <section
            className="w-screen h-screen bg-cover bg-center relative p-8"
            style={{ backgroundImage: `url(${footerBg})` }}
        >

            <SeoHelmet
                title="Yobsti – Kontaktformular"
                description="Mit dem Yobsti Kontaktformular kannst du ganz einfach Kontakt mit uns aufnehmen."
                image={seoImg}
                url="https://www.yobsti.de/kontakt"
            />

            <div className="text-textColor text-center mb-16">
                <h1 className="text-2xl sm:text-4xl font-bold p-2">Du hast Fragen, Ideen oder Feedback?</h1>
                <p className="text-sm sm:text-base mb-2 p-2">Wir freuen uns, von dir zu hören! Ob Anregung zum Sortiment, Interesse an einer Zusammenarbeit oder einfach nur Neugier – schreib uns gerne. Wir melden uns so schnell wie möglich zurück.</p>
            </div>

            <ContactForm />

        </section>
    );
}
